import { PriorityPlaylist } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/appRoutes.constants';

export const getPlaybookPath = (playlistId: number): string =>
  APP_ROUTE.PLAYBOOK.replace(':playbookId', String(playlistId));

// Not `playbook`: that key is PageShell's suggested-playlist deep link on every route.
export const TEMPLATE_PLAYBOOK_QUERY_KEY = 'template-playbook';

// A template's tasks aren't the viewer's, so the task page resolves them through the template playbook instead of by id alone.
export const getPlaybookTaskPath = (taskId: number, templatePlaylistId?: number): string => {
  const path = APP_ROUTE.PLAYBOOK_TASK.replace(':taskId', String(taskId));

  return templatePlaylistId ? `${path}?${TEMPLATE_PLAYBOOK_QUERY_KEY}=${templatePlaylistId}` : path;
};

export const getPlaylistPercentageFilled = (playlist: PriorityPlaylist): number =>
  !!playlist.completed_tasks && !!playlist.total_tasks
    ? (playlist.completed_tasks / playlist.total_tasks) * 100
    : 0;

export const handlePlaylistSearch = (
  playlists: PriorityPlaylist[],
  searchTerm: string,
): PriorityPlaylist[] => {
  if (searchTerm.length === 0) {
    return playlists;
  }

  const searchLower = searchTerm.toLowerCase();

  return playlists.filter((playlist) => {
    const searchableText = [
      playlist.title,
      playlist.description,
      playlist.marketing_description,
      playlist.keywords,
      ...(playlist.tags?.map((tag) => tag.title) ?? []),
    ]
      .join(' ')
      .toLowerCase();

    return searchableText.includes(searchLower);
  });
};
